import {IconCopy} from "@tabler/icons-react";
import PropTypes from "prop-types";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import imgZelle from "../../../assets/images/modal-icons/zelle.svg";
import {useBalanceStore} from "../../../store/useBalance.store";
import {useUserSupport} from "../../../store/useUserSupport.store";
import {PrimaryButton, SecondaryButton} from "../../Button";
import styles from "./ZelleOptions.module.css";

const ZELLE_EMAIL = "zelle@randrush.com";

const ZelleOptions = ({prev}) => {
  const handleBankAccountModal = useBalanceStore(state => state.handleBankAccountModal);
  const handleSupportModal = useUserSupport(state => state.handleSupportModal);
  const {t} = useTranslation();
  const [feedback, setFeedback] = useState(null);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(ZELLE_EMAIL);
      setFeedback({type: "success", message: t("depositInstructionsCopied")});
    } catch {
      setFeedback({type: "error", message: t("depositInstructionsError")});
    }
    setTimeout(() => setFeedback(null), 3000);
  };

  const handleSupportClick = () => {
    handleSupportModal();
    handleBankAccountModal();
    prev();
  };

  return (
    <div className={styles.container}>
      <p className={styles.description}>{t("depositInstructionsZelleMessage")}</p>

      <img
        src={imgZelle}
        alt="Zelle"
        className={styles.logo}
      />

      <p className={styles.copyHint}>{t("depositInstructionsZelleCopyBtnTitle")}</p>

      <button
        type="button"
        className={styles.copyButton}
        onClick={copyToClipboard}
      >
        <span>{ZELLE_EMAIL}</span>
        <IconCopy
          size={20}
          className={styles.copyIcon}
        />
      </button>

      {feedback && <div className={`${styles.feedback} ${styles[feedback.type]}`}>{feedback.message}</div>}

      <div className={styles.actionsBar}>
        <PrimaryButton onClick={handleSupportClick}>{t("depositInstructionsSupport")}</PrimaryButton>
        <SecondaryButton onClick={prev}>{t("depositInstructionsBack")}</SecondaryButton>
      </div>
    </div>
  );
};

ZelleOptions.propTypes = {
  prev: PropTypes.func,
};

export default ZelleOptions;
